(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legal-price-history"] && !Shopify.designMode) return;
  try {
    if (!window.TrokiLegalPriceHistoryInitialized) {
  window.TrokiLegalPriceHistoryInitialized = true;

  const syncLegalPriceHistory = (source) => {
    const scope = source?.closest?.('[data-section-id]') || document;
    const variantInput = scope.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (!variantInput || !variantInput.value) {
      return;
    }

    scope.querySelectorAll('[data-legal-price-history][data-has-variant-anchor="true"]').forEach((history) => {
      history.querySelectorAll('[data-anchor-variant-id]').forEach((row) => {
        row.hidden = row.dataset.anchorVariantId !== variantInput.value;
      });
    });
  };

  document.addEventListener('change', (event) => {
    window.setTimeout(() => syncLegalPriceHistory(event.target), 0);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-legal-price-history][data-has-variant-anchor="true"]').forEach((history) => {
      syncLegalPriceHistory(history);
    });
  });
}
  } catch(e) { console.error(e); }
})();

})();
